export enum INPUT_TYPES {
  TEXT = 'text',
  RUT = 'rut',
  EMAIL = 'email',
  PASSWORD = 'password',
}
